(function() { window.GUID_9e1809f7_1e84_4012_a8c2_953f929e7613 = { getGuid: function() { return "9e1809f7-1e84-4012-a8c2-953f929e7613"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class Gallery {
            static GalItemClick($element, e) {
                e.stopImmediatePropagation();
                var gallery = $element.data('gallery');
                let galleryData = JSON.stringify(gallery);
                let url = gallery.ShowGalleryUrl;
                if (url.indexOf("?") > -1) {
                    url = url + "&galleryData=" + galleryData;
                }
                else {
                    url = url + "?galleryData=" + galleryData;
                }
                CS.Nav.Go(url);
            }
        }
        Controls.Gallery = Gallery;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=gallery.js.map
